export const specialCharRegexp: RegExp = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;
